module.exports = __webpack_public_path__ + "static/media/poiLoadImage.cadfd834.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/poiLoadImage.svg
// module id = 421
// module chunks = 49